import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { BaseActionData } from './base-action-data';

/**
 * Représente les données d'une action 'Mise à jour d'attribut'.
 */
export class UpdateAttributeActionData extends BaseActionData {
    /**
     * id de l'attribut à mettre à jour.
     */
    public attributeId: number;

    /**
     * valeur de l'attribut à mettre à jour.
     */
    public value: string;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowActionTypes.UpdateAttribute);
    }

    /**
     * Retourne une copie d'une instance de UpdateAttributeActionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: UpdateAttributeActionData) {
        if (!!other) {
            const instance = new UpdateAttributeActionData();
            instance.attributeId = other.attributeId;
            instance.value = other.value;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
